import React from 'react';
import PropTypes, { oneOfType } from 'prop-types';

import alertType from '../../common/alertType';
import { ReactComponent as IconWarning } from '../../assets/icon/ic_warning_circle.svg';
import Button from '../Button/Button';
import ButtonTypes from '../../constants/buttonTypes';

const Alert = ({
  text, type, onAction, actionText
}) => {
  const alertData = {
    [alertType.warning]: {
      icon: <IconWarning className="text-white fill-white w-[50px] h-[50px] mr-[20px]" width={32} height={32} />,
      btnColor: ButtonTypes.INFO
    },
    [alertType.info]: {
      icon: <IconWarning className="text-white fill-white w-[50px] h-[50px] mr-[20px]" width={32} height={32} />,
      btnColor: ButtonTypes.ACTIVE_LIGHT
    },
    [alertType.important]: {
      icon: <IconWarning className="text-white fill-white w-[50px] h-[50px] mr-[20px]" width={32} height={32} />,
      btnColor: ButtonTypes.LIGHT_WARNING
    },

  };
  const typeClasses = {
    [alertType.warning]: 'bg-danger text-white',
    [alertType.info]: 'bg-primary text-white',
    [alertType.important]: 'bg-warning text-white',
  };
  return (
    <div className={`px-[26px] py-[20px] rounded-[10px] flex flex-row items-center text-[13px] ${typeClasses[type]}`}>
      {alertData[type]?.icon}
      <div className="capitalize text-[14px] font-normal">{text}</div>
      {onAction
      && (
      <div className="flex flex-1 justify-end">
        <Button
          containerStyle="px-[10px] py-[8px]"
          text={actionText}
          onClick={onAction}
          type={alertData[type]?.btnColor}
        />
      </div>
      )}
    </div>
  );
};

Alert.propTypes = {
  text: oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  type: PropTypes.string.isRequired,
  onAction: PropTypes.func,
  actionText: PropTypes.string,
};

Alert.defaultProps = {
  onAction: undefined,
  actionText: 'action'
};

export default Alert;
